import { render, staticRenderFns } from "./trafficPaymentInfo.vue?vue&type=template&id=1d4ac564&scoped=true&"
import script from "./trafficPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./trafficPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./trafficPaymentInfo.vue?vue&type=style&index=0&id=1d4ac564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ac564",
  null
  
)

export default component.exports